import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  sendOmLetterAction, 
  sendReportConsentLetterAction,
  setReportEmailAction,
  setOmLetterEmailAction,
  cleanReportErrorAction,
  setReportFileNameAction,
  setOmLetterFileNameAction,
  setClearSuccessMessageAction,
} from 'store/slices/sendOmLetter/sendOmLetterThunks';

export const useSendOmLetter = () => {
  const [uploadCheckFile, setUploadCheckFile] = useState(false);
  const [reportXlsx, setReportXlsx] = useState(null);
  const [omLetterXlsx, setOmLetterXlsx] = useState(null);

  const dispatch = useDispatch();
  const reportFileInput = useRef(null);
  const omLetterFileInput = useRef(null);

  const {
    loading,
    error,
    reportEmails,
    omLetterEmails,
    excelSample,
    reportFileName,
    omLetterFileName,
    successMsg,
  } = useSelector(state => state.OmLetter);

  const handleClickReportFile = e => {
    reportFileInput.current.click();
  };

  const handleClickOmLetterFile = e => {
    omLetterFileInput.current.click();
  }

  const handleReportXlsxChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setReportXlsx(file);
      dispatch(setReportFileNameAction(file.name));
    e.target.value = '';
    }
  };

  const handleOmLetterXlsxChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setOmLetterXlsx(file);
      dispatch(setOmLetterFileNameAction(file.name));
      e.target.value = '';
    }
  }

  const handleSendPatientsReports = () => {
    dispatch(sendReportConsentLetterAction(reportXlsx, reportEmails));
    setReportXlsx(null);
    setUploadCheckFile(false);
  };

  const handleSendOmLetter = () => {
    dispatch(sendOmLetterAction(omLetterXlsx, omLetterEmails));
    setOmLetterXlsx(null);
    setUploadCheckFile(false);
  };

  const handleDowloadExcel = () => {
    //dispatch(getResultsExcelFormatAction());
  };

  const handleReportEmailsChange = (emails) => {
    dispatch(setReportEmailAction(emails));
  }

  const handleOmLetterEmailsChange = (emails) => {
    dispatch(setOmLetterEmailAction(emails));
  }

  const handleCloseError = () => {
    dispatch(cleanReportErrorAction());
  };

  const handleClearSuccessMessage = () => {
    dispatch(setClearSuccessMessageAction());
  }

  return {
    error,
    uploadCheckFile,
    loading,
    excelSample,
    reportEmails,
    omLetterEmails,
    reportFileName,
    omLetterFileName,
    reportFileInput,
    omLetterFileInput,
    successMsg,
    handleReportXlsxChange,
    handleOmLetterXlsxChange,
    handleSendPatientsReports,
    handleDowloadExcel,
    handleSendOmLetter,
    handleReportEmailsChange,
    handleOmLetterEmailsChange,
    handleCloseError,
    handleClickReportFile,
    handleClickOmLetterFile,
    handleClearSuccessMessage
  };

}